import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home/Home";
import Privacy from "./pages/policy/privacy/Privacy";
import Service from "./pages/policy/service/Service";
import Location from "./pages/policy/location/Location";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/policy/service" element={<Service />} />
        <Route path="/policy/privacy" element={<Privacy />} />
        <Route path="/policy/location" element={<Location />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
